export enum Currency {
	Euro = 1,
	Dollar = 2
}